export default "__VITE_ASSET__jfSaMeKt__"